var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('database-picker',{attrs:{"rules":_vm.rules,"action":_vm.action,"return-id":_vm.returnId,"disabled":_vm.isDisabled,"label":"Takip Alt Tipi","item-text":"isim","default-first":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }